<template>
  <div id="StatusManagement">
    <div v-if="!waveGuid" class="sm-overview">
      <div class="sm-search-container">
        <input
          class="sm-search"
          type="text" 
          placeholder="Search" 
          v-model="search" 
          @change="getWaveData()"
        >        
      </div>
      <div class="sm-wave-container">
        <div class="sm-header">
          <div style="text-align: left;"><b>Wave</b></div>
          <div style="text-align: center;"><b>Check Status</b></div>
          <div style="text-align: center;"><b>Approvals</b></div>
        </div>
        <template v-for="wave in waveData">
          <StatusWave
            :wave="wave"
            @click="openDetails"
          />
        </template>      
      </div>
    </div>
    <template v-else>
      <button class="sm-btn" @click="waveGuid = null">
        <i class="material-icons">chevron_left</i>
        <span>Back to Overview</span>
      </button>
      <StatusWaveDetail :waveGuid="waveGuid"></StatusWaveDetail>
    </template>
  </div>
</template>

<script>
import StatusWave from './StatusWave.vue';
import StatusWaveDetail from './StatusWaveDetail.vue';

export default {
  name: 'StatusManagement',
  components:{ StatusWave, StatusWaveDetail },
  mounted(){
    this.getWaveData();
  },
  data(){
    return {
      waveData:[],
      waveGuid: null,
      approvalStatus: null,
      search: null,
    };
  },
  methods:{
    openDetails(e) { 
      this.waveGuid = e;
    },
    getWaveData() {
      $.ajax({
        url: "api/Status",
        method: "POST",
        data: JSON.stringify({ ApprovalStatus: this.approvalStatus, Search: this.search }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.waveData = [];
          if (!_.isEmpty(data)) this.waveData = data;
        },
        error: () => {
          console.error("Error on GET in getWaveData()");
        }
      });
    }
  }
};
</script>

<style lang="css" scoped>
#StatusManagement {
  background: white;
  height: calc(100vh - 60px - 20px);
  position: fixed;
  top: 60px;
  width: 100%;
}
.sm-overview {
  height: 100%;
  width: 100%;
  position: relative;
}
.sm-header {
  position: sticky;
  top: 0px;
  z-index: 1;
  width: 100%;
  height: 50px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  padding: 12px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

}
.sm-header div {
  width: 33%;
  padding-left: 12px;
}
.sm-wave-container {
  overflow: auto;
  height: calc(100% - 50px);
  padding: 0px 50px;
}
.sm-search {
  border: 1px solid lightgray;
  border-radius: 0%;
  transition: all .2s;
  padding: 5px;
  margin: 5px 50px;
  width: 20%;
  min-width: 200px;
}
.sm-search:focus {
  border: 1px solid var(--color-primary);
}
.sm-search-container {
  width: 100%;
  height: 50px;
  display: flex;
}
.sm-btn {
  display: flex;
  align-items: center;
  padding: 5px;
  margin: 5px 50px;
  border: none;
}
</style>


// WEBPACK FOOTER //
// StatusManagement.vue?6f265aa7